import styled from 'styled-components';
import {TextAreaComponent} from '../../molecules/TextInput/index';
import ContainedButton from '../../atoms/ContainedButton/index';
import {TextInputComponent} from '../../molecules/TextInput/index';
import CloseButton from '../../atoms/CloseButton/index';
import TextButton from '../../atoms/TextButton';
import InputChip from '../../molecules/InputChip';
import DropDown from '../../molecules/DropDown';
import TextInput from '../../atoms/TextInput';
import Checkbox from '../../atoms/Checkbox';
import IconButton from '../../atoms/IconButton';
import FloatingActionButton from '../../atoms/FloatingActionButton';
import DurationPicker from '../../molecules/DurationPicker';
import {TimerIcon,ArrowLeftIcon,PlusIcon,TrashIcon,PlayIcon,RemoveIcon,StatsIcon} from '../../atoms/Icons';
import {
	HoverColor,
	ColorDefs,
	DividerColor,
	Grey500,
	Grey700,
	Grey400,
	OnSurface,
	Grey600} from '../../Colors';

const defaultStyle = {
	Wrapper : styled.div`
        flex: 1;
		flex-grow : 3;
		display: flex;
		align-items: stretch; 
        align-content: stretch;
		flex-direction: column;
		height : 100%;
		overflow: hidden;
		position : relative;
		background-color : transparent;
	`,
	HeaderWrapper : styled.div`
		display : flex;
		padding : 10px;
		color : ${OnSurface};
		background-color : transparent;
		border-bottom : 1px solid ${DividerColor};
		&>button{
			margin-left : 1rem;
		}
	`,
	DescriptionWrapper : styled.div`
		display : flex;
		align-items : center;
		padding : 1rem;
		border-bottom : 1px solid ${DividerColor};
		position : relative;
	`,
	TextInputComponent : styled(TextInputComponent).attrs(
		{borderType : 'none'}
	)`
		display : block;
		flex: 1;
		font-size:2rem;
		color : ${Grey700};
		&:hover,&:focus{
			border-bottom : 1px dotted ${DividerColor};
			color : ${OnSurface};
		}
	`,
	TimerWrapper : styled.div`
		margin-left : auto;
		white-space : nowrap;
	`,
	TimerInput  : styled(TextInput).attrs(
		{ 
			borderType : 'underlined' ,
			type : 'number'
		}
	)`
		width : 10rem;
		text-align : center;
	`,
	InputChip : styled(InputChip)`
	`,
	TextAreaComponent : styled(TextAreaComponent).attrs({
		borderType : 'none'
	})`
		width : 100%;
		color : ${Grey700};
		border-radius : 3px;
		&:hover{
			border : 1px dotted ${DividerColor};
			color : ${OnSurface};
		}
	`,
	CloseButtonWrapper : styled.div`
		&:hover{
			border-radius : 0;
			background-color : ${HoverColor};
		}
		color : ${Grey500};
	`,
	CloseButton : styled(CloseButton).attrs(
		{color : Grey700}
	)`
	`,
	ArrowLeftIcon : styled(ArrowLeftIcon).attrs(
		{color : Grey700}
	)`
		margin-right : 1rem;
	`,
	RemoveIcon : styled(RemoveIcon).attrs(
		{color : Grey700}
	)`
	`,
	StatsIcon : styled(StatsIcon).attrs(
		{color : Grey700}
	)`
	`,
	QuizListIndexWrapper : styled.div`
		width : 5%;
		margin-right : 1rem;
	`,
	QuizListWrapper : styled.div`
		display : flex;
		padding-right : 10px;
		height : 60%;
		overflow: auto;
		border-bottom : 1px dotted ${DividerColor};
	`,
	ButtonsWrapper : styled.div`
		display : flex;
		margin-top : 1rem;
		margin-bottom : 1rem;
		align-items : center;
		& > .publish-checkbox {
			margin-left : 1rem;
		}
		&>:last-child{
			margin-left: auto;
		}
	`,
	IconButton : styled(IconButton)`
		color : ${Grey500};
		&:hover{
			color : ${Grey600};
		}
	`,
	UL : styled.ul`
		width : 100%;
		margin-top : 1rem;
		padding-left : 1rem;
	`,
	ActionButtonsWrapper : styled.div`
		margin-left : 2rem;
	`,
	TrashIcon,
	PlayIcon : styled(PlayIcon)`
		margin-right : 0.5rem;
	`,
	PlusIcon : styled(PlusIcon)`
		margin-right : 0.5rem;
	`,
	ContainedButton : styled(ContainedButton)`
		margin-right : 1rem;
		font-size : 2rem;
	`,
	ActionIconsWrapper : styled.div`
		margin-right : 1rem;
	`,
	StatusIconWithBottomLabel : styled(IconButton)`
		font-size : 2.5rem;
		margin-left : 2rem;
		color : ${Grey400};
		`,
	TimerIcon : styled(TimerIcon)`
		font-size : 2rem;
		margin-right : 1rem;
	`,
	TimerLabel : styled.label`
		margin-right : 0.5rem;
		&::after{
			font-size : 0.5rem;
			content : ${({caption})=>caption && `"${caption}"`}
		}
	`,
	DurationPicker,
	StatusIconLabel : styled.span`
		font-size : 1.5rem;
		margin-left : 2px;
	`,
	DropDown : styled(DropDown)`
		font-size : 2.5rem;
		color : ${Grey500};
		margin-left : 2rem;
		&:hover{
			color : ${Grey700};
		}
	`,
	Checkbox : styled(Checkbox).attrs({
		color : ColorDefs.secondary
	})`
		color : ${Grey700};
	`,
	Error : {
		Text : styled.div`
			margin-top : 5rem;
			text-align : center;
			color : ${Grey500};
			font-size : 2.5rem;
		`
	}
};

const mobileStyle = {
	Wrapper : styled.div`
		display: flex;
		flex-direction: column;
		position : relative;
		background-color : transparent;
	`,
	ArrowLeftIcon : styled(defaultStyle.ArrowLeftIcon)`
		font-size : 2rem;
	`,
	SummaryLink : styled.div`
		margin-top : 1rem;
		& > button {
			& > #summary-link-icon {
				margin-right : 1rem;
			}
		}
	`,
	ButtonsWrapper : styled.div`
		display : flex;
		justify-content: space-between;
		align-items : center;
		padding : 1rem;
	`,
	Actions : styled.div`
		padding : 1rem;
	`,
	QuizListWrapper : styled.div`
		display : flex;
		flex-direction : column;
		min-height : 50vh;
		padding-right : 10px;
		border-bottom : 1px dotted ${DividerColor};
		&>:last-child {
			margin-top : auto;
		}
	`,
	HelpWrapper : styled.div`
		height : 40vh;
		display : flex;
		align-items : center;
	`,
	ActionButtonsWrapper : styled.div`
		padding : 1rem;
		text-align : right;
	`,
	FloatingActionButton : styled(FloatingActionButton)`
		border-radius : 50%;
		padding : 2rem;
		margin-right : 1rem;
		font-size : 1.5rem;
		width: 60px;
  		height: 60px;
	`,
	PlayIcon : styled(PlayIcon)`
	`,
	PlusIcon : styled(PlusIcon)`
	`,
	TimerIconButton : styled(defaultStyle.IconButton)`
		font-size : 2rem;
	`,
	TextButton,
};

export default defaultStyle;
export {mobileStyle};
